module.exports = __webpack_public_path__ + "img/dados-coletados.1e3bc69e.png";